(() => {
  if (customElements.get('bbw-article-title-logos')) return;

  class BbwArticleTitleLogos extends HTMLElement {
    connectedCallback() {
      const token = this.dataset.token;
      const body = this.querySelector('.bbw-article__content');
      const template = this.querySelector('template[data-title-logo-template]');
      const sourceImage = template?.content.querySelector('img');

      if (!token || !body || !sourceImage) return;

      body.querySelectorAll('h2').forEach((heading) => {
        if (heading.hasAttribute('data-title-logo-applied')) return;

        if (this.replaceFirstToken(heading, token, sourceImage)) {
          heading.setAttribute('data-title-logo-applied', '');
        }
      });
    }

    replaceFirstToken(heading, token, sourceImage) {
      const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      let combinedText = '';
      let textNode = walker.nextNode();

      while (textNode) {
        const start = combinedText.length;
        combinedText += textNode.data;
        textNodes.push({ node: textNode, start, end: combinedText.length });
        textNode = walker.nextNode();
      }

      const tokenStart = combinedText.indexOf(token);
      if (tokenStart === -1) return false;

      const tokenEnd = tokenStart + token.length;
      const startText = textNodes.find(({ start, end }) => tokenStart >= start && tokenStart < end);
      const endText = textNodes.find(({ start, end }) => tokenEnd > start && tokenEnd <= end);
      if (!startText || !endText) return false;

      const range = document.createRange();
      range.setStart(startText.node, tokenStart - startText.start);
      range.setEnd(endText.node, tokenEnd - endText.start);
      range.deleteContents();
      range.insertNode(sourceImage.cloneNode(true));
      range.detach();
      return true;
    }
  }

  customElements.define('bbw-article-title-logos', BbwArticleTitleLogos);
})();
